import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { getDateDescription } from 'flow/utils';
import { twMerge } from 'tailwind-merge';

interface Props {
    date?: string;
    className?: string;
    /** Dark variant, for the in-meeting video chat only — see DateDivider. */
    videoDark?: boolean;
}

const MessageGroupDivider = ({ date, className, videoDark = false }: Props) => {
    const { i18next } = useAppContext();

    const isDated = !!date;

    let testId = 'message-unread-banner';
    let backdropClassName = 'bg-white';
    let lineClassName = 'bg-red';
    let pillClassName = 'border-red bg-white';
    let textClassName = 'text-red';
    let label = i18next.t('chat.flowfeed.new_messages');

    if (videoDark) {
        backdropClassName = 'bg-gray-800';
    }

    // The "unread" banner (isDated false) always reads red, on either theme;
    // only the dated pill switches with videoDark.
    if (isDated && videoDark) {
        testId = 'message-group-divider';
        lineClassName = 'bg-gray-600';
        pillClassName = 'border-gray-600 bg-gray-800';
        textClassName = 'text-gray-300';
        label = getDateDescription(date, i18next);
    } else if (isDated) {
        testId = 'message-group-divider';
        lineClassName = 'bg-gray-300';
        pillClassName = 'border-gray-300 bg-white';
        textClassName = 'text-gray-700';
        label = getDateDescription(date, i18next);
    }

    return (
        <div data-test-id={testId} className="sticky -top-6 z-10 w-full">
            <div
                className={twMerge(
                    'absolute h-3/4 w-full',
                    backdropClassName,
                    className,
                )}
            />
            <div className="relative w-full px-4 pt-6">
                <div className="relative w-full">
                    <div
                        className={twMerge(
                            'absolute start-0 top-1/2 z-0 h-[1px] w-full',
                            lineClassName,
                        )}
                    />
                    <div className="flex w-full justify-center">
                        <div
                            className={twMerge(
                                'relative flex h-6 items-center rounded-sm border px-3 py-0.5',
                                pillClassName,
                            )}
                        >
                            <span
                                className={twMerge(
                                    'text-xs font-bold',
                                    textClassName,
                                )}
                            >
                                {label}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessageGroupDivider;
